import stringSimilarity from "string-similarity-js";
import store from "../store";

export const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const getSrc = (picturePath: string) => picturePath && typeof picturePath === "string"
  ? `${process.env.VUE_APP_API_ENDPOINT}${picturePath}`
  : null;

export const getTokenLink = (path: string): string => {
  const url = new URL(
    path,
    store.state.baseURL,
  );
  url.searchParams.set("token", store.getters["oauth/getAccessToken"]);

  return url.toString();
};

export const removeVuetifyFileInputBug: (document: any) => void = (document: any): void => {
  // TODO: Remove this function and all usages after Vuetify version update after correction of the bug
  // TODO: Follow the fixing of the bug: https://github.com/vuetifyjs/vuetify/issues/10832
  const inputs = document.querySelectorAll(".v-file-input input");
  [...inputs].forEach((input: any) => {
    input.remove();
  });
};

export const lastItemOfArray: (array: any[]) => any = (array: any[]): any => {
  return array?.[array?.length - 1];
};

export const concatListElem: (elem?: string) => string = (elem?: string): string => {
  return elem ? `, ${elem}` : "";
};

export const areArraysEquals = (a: any[], b: any[], compareFunction: (x, y) => boolean = (x, y) => x === y) => {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((vala) => b.some((valb) => compareFunction(vala, valb))) &&
    b.every((valb) => a.some((vala) => compareFunction(vala, valb)))
  );
};

export const removeDuplicates = (array: any[], property: string = "id") => {
  const seen = new Set();
  return array.filter((item) => {
    const key = item[property];
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export const formattedTextValuesArray: (arr: any[], lang: string) => Array<{ text: string, value: number }> =
    (arr: any[], lang: string) => arr.map((item: any) => ({
        text: item[lang]?.toString(),
        value: Number(item.id),
}));

export const toCamelCase = (sentence: string): string => {
  // Remove special characters and split the sentence into words
  const words: string[] = sentence
    .replace(/[^a-zA-Z ]/g, "")
    .split(" ");

  // Convert the first word to lowercase and keep the rest as-is
  const camelCaseWords: string[] = words.map((word: string, index: number): string => index === 0
    ? word.toLowerCase()
    : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );

  // Join the words back together to form the camelCase string
  return camelCaseWords.join("");
};

export const generateUID = () => {
  // tslint:disable-next-line
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // tslint:disable-next-line
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    // tslint:disable-next-line
    return v.toString(16)
  });
};

export const formatPhone = (phone: string): string|null => {
  // The goal of this function is to return a mobile number formatted like this :
  // +336XXXXXXXX (for mobile french numbers)
  // For foreign numbers, there is no ultimate way to ensure good formatting
  // We can only replace the starting '00' by '+' and pray that the country code and number following are correct

  const regex = {
    invalidCharacters: /[^+0-9]/g, // Any other character than numbers or '+'
    frenchMobileClassic: /^(06|07)(\d{8})$/, // classic mobile french number
    // frenchMobileError1: /^(6|7)(\d{8})$/, // missing country code or '0'
    frenchMobileError2: /^33(6|7)(\d{8})$/, // missing '+' before country code
    frenchMobileError3: /^(\+33)(06|07)(\d{8})$/, // invalid '0' between country code and number
  };
  // First, clean phone number from invalid characters
  phone = phone.replace(regex.invalidCharacters, "");
  // For all numbers, replace the starting '00' by '+'
  if (phone.slice(0, 2) === "00") {
    phone = phone.replace("00", "+");
  }
  if (regex.frenchMobileClassic.test(phone)) {
    // Replace the '0' by '+33'
    phone = phone.replace("0", "+33");
  }
  // if (regex.frenchMobileError1.test(phone)) {
  //   // Add the missing country code before the actual number
  //   phone = '+33' + phone
  // }
  if (regex.frenchMobileError2.test(phone)) {
    // Add the missing '+' before country code
    phone = "+" + phone;
  }
  if (regex.frenchMobileError3.test(phone)) {
    // Remove the '0' between '+33' and the actual number
    phone = phone.replace("+330", "+33");
  }
  return phone || null;
};

export const formattedTranslationValues = (arr: any[], lang: string) => {
  return arr.map((value: any) => {
    return { text: value[lang], value: value.id };
  });
};

/**
 * Generates a map link based on the provided latitude and longitude coordinates.
 *
 * @param {number} lat - The latitude coordinate.
 * @param {number} long - The longitude coordinate.
 * @returns {string} The generated map link.
 */
export const getMapLink = (lat, long): string => {
  return `https://maps.google.com/?q=${lat},${long}`;
};

// en mètres
export const haversineDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number => {
  const R = 6371000; // Earth radius in meters
  const toRad = (value: number) => (value * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) *
    Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(R * c); // Distance in meters (integer, no decimals)
};

export const degreeDiffInMeters = (
  lat1: number,
  lat2: number | string): number => {
  if (!lat2) { lat2 = 0; }
  const lat2Num = typeof lat2 === "string" ? parseFloat(lat2) : lat2;
  const DEGREE_TO_METERS = 111320;
  return Math.abs(lat1 - lat2Num) * DEGREE_TO_METERS;
};

export const distanceGreaterThan = (
  coord1: number,
  coord2: string,
): boolean => {

  const LIMIT = 100;
  return (degreeDiffInMeters(coord1, coord2)) >= LIMIT;
};

export const stringComparaison = (
  addr1: string,
  addr2: string,
): boolean => {

  const STRING_DIFF_LIMIT = 0.8;
  return stringSimilarity(addr1, addr2) >= STRING_DIFF_LIMIT;
};
